// extracted by mini-css-extract-plugin
export default {"container":"StartGamePage_container__UHc6j"};